import PropTypes      from 'prop-types'
import React          from 'react'
import { withRouter } from 'react-router'
import { Link       } from 'react-router-dom'
import { Alert }      from 'react-bootstrap'
import FocusLock      from 'react-focus-lock'

import { LoginLink            } from 'alto-react-client-auth/lib/routes'
import { webLogin             } from 'alto-react-canteen/lib/routes'
import { terminalLoginSetting } from 'alto-react-canteen/lib/settings'
import { TerminalLoginService } from 'alto-react-canteen/lib/services'

import './with_card_login.sass'

class WithCardLogin extends React.Component
  @contextTypes = { auth: PropTypes.object, backend: PropTypes.object, settings: PropTypes.object }

  constructor: (props, context) ->
    super(props, context)

    @terminalLogin = terminalLoginSetting(context.settings)
    @state         = { isTerminal: false, cardNumber: '', loginErrors: null }

  componentWillMount: ->
    if @terminalLogin.enabled
      @context.auth.isRegisteredTerminal()
        .then ({ isRegistered }) => @setState(isTerminal: isRegistered)

  render: ->
    <div>
      {@loggedOutAlert()}
      {@loginFailedAlert()}
      {@props.children}
      {@cardNumberInput()}
    </div>

  loggedOutAlert: ->
    action    = @props.action or 'pokračování'
    loginLink =
      <Link to={{ pathname: webLogin, state: { terminal: @state.isTerminal } }}>
        <strong>přihlaste</strong>
      </Link>

    if @state.isTerminal
      additional = <React.Fragment>&nbsp;nebo <strong>přiložte kartu</strong></React.Fragment>

    <Alert>Jste odhlášeni. Pro {action} se {loginLink}{additional}.</Alert>

  loginFailedAlert: ->
    if @state.loginErrors
      <Alert id="login-alert" bsStyle="danger">{@state.loginErrors.message}</Alert>

  cardNumberInput: ->
    if @state.isTerminal
      <FocusLock persistentFocus={true}>
        <input className='transparent'
               value={@state.cardNumber}
               onChange={(event) => @setState(cardNumber: event.target.value)}
               onKeyPress={(event) => @logIn() if event.key == 'Enter'} />
      </FocusLock>

  logIn: ->
    if @state.cardNumber.length
      service = new TerminalLoginService(@context.auth, @context.settings, @props.history)
      service.perform(@state.cardNumber)
        .catch TerminalLoginService.Failed, (error) => @setState(cardNumber: '', loginErrors: error.data)

export WithCardLogin = withRouter(WithCardLogin)

export default withCardLogin = (Component, props = {}) ->
  -> <WithCardLogin {...props}><Component /></WithCardLogin>
